module.exports = __webpack_public_path__ + "img/heart-empty.d0d6918e.svg";